import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBugattiComponent } from './simple-icons-bugatti.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBugattiComponent ],
    exports:      [ SimpleIconsBugattiComponent ],
    bootstrap:    []
})
export class SimpleIconsBugattiModule {}
